import httpAuth from "@/common/http-common";
import { 
  Medication, 
  Imei,
  ParticipantStatus,
  ParticipantDetailModel
} from "@/views/sidebar/participant/participant.types";

class ParticipantService {
  async GetActiveMedications(clientId: number) {
    const { data } = await httpAuth().get<Medication[]>(
      '/Research/GetActiveMedications', { params: {
        clientId: clientId
      } 
    });
    return data;
  }

  async GetActiveImeis(clientId: number) {
    const { data } = await httpAuth().get<Imei[]>(
      '/Research/GetActiveImeis', { params: {
        clientId: clientId
      } 
    });
    return data;
  }

  async UpsertParticipantDetails(participantDetailModel: ParticipantDetailModel) {
    const { data } = await httpAuth().post(
      `/Research/UpsertParticipantDetails`, 
      participantDetailModel 
    );
    return data;
  }

  async GetParticipantStatus(clientId: number) {
    const { data } = await httpAuth().get<ParticipantStatus[]>(
      '/Research/GetParticipantStatus', { params: {
        clientId: clientId
      } 
    });
    return data;
  }
}

export default new ParticipantService();